"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HydrationStats = exports.YearHydrationStats = exports.WeekHydrationStats = exports.UserWithGoals = exports.Goals = exports.GoalsBody = exports.ManualDispenseBody = exports.DeviceDispenseBody = exports.LoyaltyProgramStatusList = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const entity_1 = require("../../../../../../entity");
const Device = __importStar(require("../../../../../device"));
const User = __importStar(require("../../../../../user"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.User.Schema';
/*
 * `controllers/v2/user/index.js` (protocol v2, `PublicRouteGuard`)
 */
/** `S.Array(Culligan.User.UserLoyaltyProgramStatus)` */
exports.LoyaltyProgramStatusList = effect_1.Schema.Array(User.UserLoyaltyProgramStatus).annotations({
    identifier: `${exports.NAMESPACE}.LoyaltyProgramStatusList`,
    description: 'Loyalty program statuses of the user updated in the range',
});
/**
 * `UserDispensingHistoryItemWithoutIdentifiers`: a `UserDispense` without
 * `id` and the timestamps. The controller decodes with `newEntity(...).pipe(S.omit('id'))`,
 * so `userId` stays required even though the server replaces it with the
 * session user.
 */
exports.DeviceDispenseBody = (0, entity_1.newEntity)(Device.History.UserDispense)
    .pipe(effect_1.Schema.omit('id'))
    .annotations({
    identifier: `${exports.NAMESPACE}.DeviceDispenseBody`,
    title: 'UserDispensingHistoryItem',
    description: 'A drink dispensed from a device to record for the session user. `userId` must be present but is overwritten with the session user.',
});
/** `UserManualDispensingHistoryItem.pick('drinkSize')` */
exports.ManualDispenseBody = User.UserManualDispensingHistoryItem.pipe(effect_1.Schema.pick('drinkSize')).annotations({
    identifier: `${exports.NAMESPACE}.ManualDispenseBody`,
    title: 'UserManualDispensingHistoryItem',
    description: 'A drink the session user recorded by hand',
});
exports.GoalsBody = effect_1.Schema.Struct({
    userId: User.Id,
    day: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({ description: 'Daily hydration goal' }),
}).annotations({
    identifier: `${exports.NAMESPACE}.GoalsBody`,
    title: 'UserGoal',
});
/** The user record after `goals` was set: the fields the route reads back. */
exports.Goals = effect_1.Schema.Struct({
    day: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.Goals`,
    description: 'Daily hydration goal',
});
exports.UserWithGoals = effect_1.Schema.Struct({
    id: User.Id,
    goals: exports.Goals,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserWithGoals`,
    title: 'User with goals',
    description: 'The updated user document. Only `id` and `goals` are part of the contract; the rest of the stored record is returned as is.',
});
/** `getWeeklyHydrationStats` / `getYearlyHydrationStats` */
exports.WeekHydrationStats = effect_1.Schema.Struct({
    hydration: effect_1.Schema.Struct({
        average: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({ description: 'Daily average, floored' }),
        total: effect_1.Schema.Number,
        history: User.WeekHistorySchema,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.WeekHydrationStats`,
    title: 'Weekly hydration',
});
exports.YearHydrationStats = effect_1.Schema.Struct({
    hydration: effect_1.Schema.Struct({
        average: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({ description: 'Monthly average, floored' }),
        total: effect_1.Schema.Number,
        history: User.YearHistorySchema,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.YearHydrationStats`,
    title: 'Yearly hydration',
});
exports.HydrationStats = effect_1.Schema.Union(exports.WeekHydrationStats, exports.YearHydrationStats).annotations({
    identifier: `${exports.NAMESPACE}.HydrationStats`,
    description: 'Weekly or yearly hydration, depending on `aggregation`',
});
//# sourceMappingURL=schema.js.map